<template>
  <div>
    <el-form :model="entity" :rules="rules" ref="form" label-width="100px">
      <el-row>
        <el-col :span="16">
          <el-form-item label="编码" prop="code">
            <el-input v-model="entity.code" placeholder="不填写由系统生成"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="entity.name"></el-input>
          </el-form-item>
           <!-- <el-form-item label="所属商户" prop="merchantId">
            <merchant-select v-model="entity.merchantId"></merchant-select>
          </el-form-item> -->
          <el-form-item label="免费时长" prop="freeMinutes">
            <el-input v-model.number="entity.freeMinutes" maxlength="11"><template slot="append">分钟</template></el-input>
          </el-form-item>
          <el-form-item label="所在区域" prop="areaCode">
            <area-cascader v-model="entity.areaCode"></area-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="entity.address"></el-input>
          </el-form-item>
          <el-form-item label="地理位置" prop="lng">
            <el-col :span="8">
              <el-input placeholder="经度" v-model="entity.lng"></el-input>
            </el-col>
            <el-col class="line" :span="1" style="text-align:center">-</el-col>
            <el-col :span="8">
              <el-input placeholder="维度" v-model="entity.lat"></el-input>
            </el-col>
            <el-col :span="3" style="padding:0 5px">
              <el-button type="text" class="el-icon-location" title="选择位置" @click="selectLocation"></el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="entity.status">
              <el-option v-for="item in $dict.store.STATUS" :key="item[0]" :value="item[0]" :label="item[1]"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div style="margin:10px">
            <v-image-uploader :form-data="{}" v-model="entity.logo">

            </v-image-uploader>
            <div style="text-align:center">
              LOGO
            </div>
          </div>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="entity.remark"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </el-form-item>
    </el-form>
    <v-dialog ref="mapDiag" title="选择位置" :append-to-body="true">
      <a-map-location style="width:100%;height:500px" @location-click="onLocationClick"></a-map-location>
    </v-dialog>
  </div>
</template>
<style lang="less" scoped>
.el-upload-dragger {
  img {
    width: 300px;
    height: 300px;
  }
}
</style>

<script>
import AreaCascader from "@/components/widgets/AreaCascader";
import AMapLocation from "@/components/widgets/AMapLocation";
import CorpSelect from "@/components/widgets/CorpSelect.vue";
import MerchantSelect from "@/components/widgets/MerchantSelect.vue";
const defaultEntity = {
  id: null,
  logo: "",
  code: "",
  name: "",
  merchantId:null,
  areaCode: "",
  lng: null,
  lat: null,
  freeMinutes: 15,
  status: 1,
  remark: ""
};
export default {
  components: { AreaCascader, AMapLocation, CorpSelect,MerchantSelect },
  data() {
    return {
      entity: _.cloneDeep(defaultEntity),
      types: [],
      rules: {
        freeMinutes: [
          {
            type: "number",
            required: true,
            message: "免费时长不能为空",
            trigger: "blur"
          }
        ],
        areaCode: [
          {
            required: true,
            message: "请选择区域",
            trigger: "change"
          }
        ],
        lng: [
          {
            type: "number",
            required: true,
            message: "经维度不能为空",
            trigger: "blur"
          }
        ],
        lat: [
          {
            type: "number",
            required: true,
            message: "经维度不能为空",
            trigger: "blur"
          }
        ],
        address: [
          { required: true, message: "详细地址不能为空", trigger: "blur" }
        ],
        name: [
          { required: true, message: "中文名称不能为空", trigger: "blur" },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到 128 个字符",
            trigger: "blur"
          }
        ],
        status: [
          {
            type: "number",
            required: true,
            message: "请选择状态",
            trigger: "change"
          }
        ],
        merchantId:[
          {
            required: true,
            message: "请选择商户",
            trigger: "change"
          }
        ],
      }
    };
  },
  methods: {
    selectLocation() {
      this.$refs.mapDiag.show({ address: this.entity.address });
    },
    onLocationClick(l) {
      this.entity.lng = l.lng;
      this.entity.lat = l.lat;
      this.$refs.mapDiag.hide();
    },
    setValues(vals) {
      this.resetEntity = _.cloneDeep(vals);
      this.entity = _.cloneDeep(this.resetEntity);
    },
    submitForm() {
      this.$refs["form"].validate((valid,err) => {
        
        if (valid) {
          let params = _.cloneDeep(this.entity);
          params.apiSecret=this.entity.code;
          this.$api.ipark.ParkInfoService.save(this.entity).then(rsp => {
            this.$emit("saved", rsp);
          });
        }
      });
    },
    resetForm() {
      this.$refs['form'].resetFields();
      this.entity = _.cloneDeep(this.resetEntity);
    },
    init(options) {
      this.resetEntity =  _.cloneDeep(defaultEntity);
      this.resetForm();
      if (options.id) {
        //loadData
        this.$api.ipark.ParkInfoService.get(options.id).then(r => {
          this.entity = r;
        });
      }
    }
  },
  mounted() {
    this.$on("init", this.init);
    this.$on("submit", this.submitForm);
  }
};
</script>


// WEBPACK FOOTER //
// Form.vue?1210043e